import { s as setContext, g as getContext, d as derived } from "./index2.js";
import { i as invalidate } from "./client2.js";
import { error } from "@sveltejs/kit";
class Cart {
  cartItems = [];
  // { id: 1, productId: 1, quantity: 2, product: { id: 1, name: 'product1', price: 100, Image: { url: 'url' } } }
  cartopen = false;
  isLoading = false;
  #cartStats = derived(() => {
    let quantity = 0, total = 0;
    for (let item of this.cartItems) {
      quantity += item.quantity;
      const unit = item.product.discountedPrice ?? item.product.price;
      total += unit * item.quantity;
    }
    return { total, quantity };
  });
  get cartStats() {
    return this.#cartStats();
  }
  set cartStats($$value) {
    return this.#cartStats($$value);
  }
  async addItem(product) {
    const existingItem = this.cartItems.find((item) => item.product.id === product.id);
    const newQuantity = (existingItem?.quantity || 0) + 1;
    if (newQuantity > product.quantity) {
      return {
        success: false,
        error: `Only ${product.quantity} item${product.quantity !== 1 ? "s" : ""} left in stock`
      };
    }
    if (existingItem) {
      existingItem.quantity = newQuantity;
    } else {
      this.cartItems = [
        ...this.cartItems,
        // TODO - use crypto.randomUUID() instead
        {
          id: Math.random() * Date.now(),
          productId: product.id,
          quantity: 1,
          product
        }
      ];
    }
    const saved = await this.saveCart();
    return { success: saved };
  }
  async saveCart() {
    this.isLoading = true;
    const cartItems = this.cartItems.map((item) => {
      return { productId: item.product.id, quantity: item.quantity };
    });
    try {
      const response = await fetch("/api/cart", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(cartItems)
      });
      if (!response.ok) throw error(response.status, await response.json());
      return true;
    } catch (e) {
      console.error(e);
      if (e?.status === 401) {
        return true;
      }
      return false;
    } finally {
      this.isLoading = false;
      invalidate();
    }
  }
  // async loadCart() {
  // 	try {
  // 		const response = await fetch('/api/cart');
  // 		if (response.ok) {
  // 			const cartItemsRes = await response.json();
  // 			this.cartItems = cartItemsRes.map((item: CartItems) => {
  // 				return {
  // 					id: item.id,
  // 					productId: item.productId,
  // 					quantity: item.quantity,
  // 					product: item.product
  // 				};
  // 			});
  // 			console.log('Loaded CartItems: -->  ', this.cartItems);
  // 		}
  // 		if (response.status === 401) {
  // 			console.error('Unauthorized loading cart: No user logged in');
  // 			await goto('/login');
  // 			return;
  // 		}
  // 		if (response.status === 404) {
  // 			console.log('Empty Cart loaded');
  // 			this.cartItems = [];
  // 		}
  // 		console.log('EndLoadCart: ', response, await response.json());
  // 	} catch (e) {
  // 		console.error(e);
  // 		this.cartItems = []
  // 	}
  // }
  async removeItem(id) {
    this.cartItems = this.cartItems.filter((item) => item.id !== id);
    if (this.cartStats.quantity === 0) this.cartopen = false;
    return await this.saveCart();
  }
  // save(){
  //     localStorage.setItem('cart', JSON.stringify(this.cartItems));
  // }
  constructor(cartItems = []) {
    this.cartItems = cartItems;
  }
}
const STATE_KEY = Symbol("cart-store-key");
function setCartState(cartItems) {
  const newCart = new Cart(cartItems);
  setContext(STATE_KEY, newCart);
  return newCart;
}
function getCartState() {
  return getContext(STATE_KEY);
}
export {
  getCartState as g,
  setCartState as s
};
